"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.experimentsByCustomerIdReducer = void 0;
exports.experimentsByCustomerIdReducer = (state = {}, action = {}) => {
    switch (action.type) {
        case 'EXPERIMENTS_GET_BY_CUSTOMER_RECEIVE':
            return Object.assign(Object.assign({}, state), { [action.payload.id]: action.payload.experiments });
        default:
            return state;
    }
};
//# sourceMappingURL=reducer.js.map